module.exports = __webpack_public_path__ + "img/mind_background_7.300a922e.png";